export default class MainMenuContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "MainMenu";
  }

  show(path, model) {
    const pageId = this.pageId;
    const app = this.app;

    app.updateLevel();
    app.updateAchievementProgress();
    app.disconnect();
    //app.showAd();

    //get model
    if (!model) model = this.load();

    app.populate(pageId, model);
    app.swapPage(pageId);
  }
  load() {
    const app = this.app;
    const userdata = app.userdata || {};
    const config = app.config;
    const advertisement = app.advertisement;
    let canRemoveAds = app.IAP.isAvailable && !app.userdata.removeAds && !app.userdata.fullVersion;
    let isfullVersion = userdata.fullVersion || userdata.removeAds;
    let isRewardedAdLoaded =  true; // advertisement.isRewardedAdLoaded(); // ad prodiver code does not preload rewarded ads currently
    let showMoreGames = app.portal?.hideMoreGames !== true && app.fullVersion !== true;
    let model = {
      resource: app.resource,
      userdata: userdata,
      canRemoveAds: canRemoveAds,
      news: app.news,
      fullVersion: isfullVersion,
      version: app.version,
      isRewardedAdLoaded: isRewardedAdLoaded,
      showMoreGames: showMoreGames
    };
    return model;
  }
  tapVersion() {
    const app = this.app;
    this.tapVersionCount = (this.tapVersionCount || 0) + 1;
    if (this.tapVersionCount > 5) {
      app.navigate("Test");
    }
  }
  tapOnTitle() {
    const app = this.app;
    app.userdata.titleTapped = (app.userdata.titleTapped || 0) + 1;
    app.achievements.checkForAchievementAndReward(app.userdata, app.userdata);
  }
}
